import React from "react";
import Layout from "@/components/layout/Layout";
import { Server, ExternalLink } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const examples = [
  {
    title: "Get latest block number",
    curl: `curl -s ${BACKEND}/api/stats | jq '.latest_block'`,
    desc: "Returns the current head block number of Ethereum.",
  },
  {
    title: "Get a block by number",
    curl: `curl -s ${BACKEND}/api/blocks/120`,
    desc: "Full block header, gas usage, transactions.",
  },
  {
    title: "Get a transaction by hash",
    curl: `curl -s ${BACKEND}/api/transactions/{hash}`,
    desc: "Full transaction detail including gas, fee, status.",
  },
  {
    title: "Get address balance and history",
    curl: `curl -s ${BACKEND}/api/address/0xc850d68d09080506ea8bb7e2b8bc4190fe021b39`,
    desc: "ETH balance, token holdings, recent transactions.",
  },
  {
    title: "List tokens",
    curl: `curl -s ${BACKEND}/api/tokens`,
    desc: "All ERC-20 tokens with live prices and holder counts.",
  },
  {
    title: "Global search",
    curl: `curl -s '${BACKEND}/api/search?q=0x...'`,
    desc: "Fuzzy search across addresses, tx hashes and blocks.",
  },
];

export default function Rpc() {
  return (
    <Layout>
      <div className="flex items-center gap-3 mb-2">
        <Server className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold" data-testid="rpc-title">RPC / HTTP Endpoint</h1>
      </div>
      <p className="text-sm text-[var(--ks-text-soft)] mb-6">
        Public read-only HTTP API. All routes are prefixed with <span className="mono">/api</span>. No authentication required for read endpoints.
      </p>

      <div className="ks-card p-4 mb-4" data-testid="rpc-base">
        <div className="text-sm font-semibold mb-1">Base URL</div>
        <div className="mono bg-[var(--ks-surface)] border border-[var(--ks-border)] rounded p-3 text-sm break-all">
          {BACKEND || "https://your-backend"}/api
        </div>
      </div>

      <div className="space-y-3">
        {examples.map((e, i) => (
          <div key={i} className="ks-card p-4" data-testid={`rpc-example-${i}`}>
            <div className="font-semibold mb-1">{e.title}</div>
            <div className="text-xs text-[var(--ks-text-soft)] mb-2">{e.desc}</div>
            <pre className="bg-[var(--ks-surface)] border border-[var(--ks-border)] rounded p-3 font-mono text-xs overflow-auto">{e.curl}</pre>
          </div>
        ))}
      </div>

      <div className="mt-6 text-sm text-[var(--ks-text-soft)] flex items-center gap-1">
        <ExternalLink size={14} /> Full reference available on the <a href="/api-docs" className="ks-link">API Documentation</a> page.
      </div>
    </Layout>
  );
}
